import React, { forwardRef } from 'react'

import { Link } from 'react-router-dom'
import { UserMenu as ReactAdminUserMenu, useGetIdentity, useUserMenu } from 'react-admin'
import GroupIcon from '@mui/icons-material/Group'
import MenuItem from '@mui/material/MenuItem'
import SettingsIcon from '@mui/icons-material/Settings'

import { Divider, Typography } from 'antd'
import { User } from 'shared/types'
import { UserAvatar } from 'shared/atoms/UserAvatar'
import Auth from 'dash/auth'

const UserMenuHeader = forwardRef<any, any>(({ user }: { user: User }) => {
  return (
    <div
      style={{ display: 'flex', flexDirection: 'row', padding: '6px 16px', paddingLeft: '12px', alignItems: 'center' }}
    >
      <UserAvatar name={user.name || user.email} src={null} size={32} />
      <div style={{ marginLeft: 6, display: 'flex', flexFlow: 'column nowrap' }}>
        <Typography.Text
          strong
          style={{
            lineHeight: 1,
          }}
        >
          {user.name}
        </Typography.Text>
        <Typography.Text
          type="secondary"
          style={{
            lineHeight: 1.5,
          }}
        >
          {user.email}
        </Typography.Text>
        {/* <div>Github Icon</div>
        <div>2FA Enabled</div> */}
      </div>
    </div>
  )
})

const ConfigurationMenu = forwardRef<any, any>(({ user }, ref) => {
  const { onClose } = useUserMenu()
  return (
    <MenuItem
      // ref={ref}
      component={Link}
      to="/user/me"
      onClick={onClose}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <SettingsIcon /> <span style={{ marginLeft: 10 }}>Preferences</span>
      </div>
    </MenuItem>
  )
})

const AccountMenu = () => {
  const { onClose } = useUserMenu()
  return (
    <MenuItem to="/user/membership" component={Link} onClick={onClose}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <GroupIcon /> <span style={{ marginLeft: 10 }}>Accounts</span>
      </div>
    </MenuItem>
  )
}

export const UserMenu = () => {
  const { identity, isLoading: identityLoading } = useGetIdentity()

  if (identityLoading) return null

  const { user } = identity

  return (
    <ReactAdminUserMenu>
      {user && <UserMenuHeader user={user} />}
      <div style={{}}>
        <Divider
          style={{
            margin: '8px 0',
          }}
        />
      </div>
      {user && <ConfigurationMenu user={user} />}
      <AccountMenu />
      <Auth.LogoutButton />
    </ReactAdminUserMenu>
  )
}
